import { DEFAULT_POLL_QUESTION_TYPES, MULTI_CHOICE_QUESTIONS, NON_MULTI_CHOICE_QUESTIONS } from './questionTypes';

const defaultPollQuestionConfig = [
  {
    forTypes: DEFAULT_POLL_QUESTION_TYPES,
    maxOptions: 10,
    customConfigs: [
      {
        id: 'comments',
        label: 'Allow comments',
      },
    ],
    hideRequired: true,
  },
];

const defaultSurveyQuestionConfig = [
  {
    forTypes: MULTI_CHOICE_QUESTIONS,
    maxOptions: 20,
    customConfigs: [
      {
        id: 'comments',
        label: 'Allow comments',
      },
    ],
    hideRequired: true,
  },
  {
    forTypes: NON_MULTI_CHOICE_QUESTIONS,
    customConfigs: [{}],
    hideRequired: true,
  },
];

export const getDefaultQuestionConfig = surveyType => {
  if (surveyType === 'poll') {
    return defaultPollQuestionConfig;
  }
  return defaultSurveyQuestionConfig;
};

export const getQuestionConfigs = (configs, surveyType) => {
  let questionArray = [];
  let disabledQuestionTypes = [];
  let maxAnsChoices;

  const questionConfigOverride = !configs ? getDefaultQuestionConfig(surveyType) : configs;

  questionConfigOverride.forEach(({ forTypes = [], maxOptions, disabled }) => {
    const isMCQuestions = forTypes.every(val => MULTI_CHOICE_QUESTIONS.includes(val));
    if (isMCQuestions && maxOptions) {
      maxAnsChoices = maxOptions;
    }
    if (disabled) {
      disabledQuestionTypes = disabledQuestionTypes.concat(forTypes);
    } else {
      questionArray = questionArray.concat(forTypes);
    }
  });

  return {
    enabledQuestionTypes: questionArray,
    disabledQuestionTypes,
    config: questionConfigOverride,
    maxAnsChoices,
  };
};

export const sendMessage = (msg, domain) => {
  window.parent.postMessage(msg, domain);
};
